import {
    MAGENTO_CATEGORIES_FETCH_FAILURE_FOR_HURTON,
    MAGENTO_CATEGORIES_FETCH_SUCCESS_FOR_HURTON,
    MAGENTO_CATEGORIES_FETCHING_FOR_HURTON,
} from '../actions/types'

const INITIAL_STATE = {
    items: {},
    fetching: false,
}

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case MAGENTO_CATEGORIES_FETCHING_FOR_HURTON:
            return {
                ...state,
                fetching: true,
            }

        case MAGENTO_CATEGORIES_FETCH_SUCCESS_FOR_HURTON:
            return {
                ...state,
                items: prepareCategories(action.payload),
                fetching: false,
            }

        case MAGENTO_CATEGORIES_FETCH_FAILURE_FOR_HURTON:
            return {
                ...state,
                fetching: false,
            }

        default:
            return state
    }
}

const prepareCategories = magentoCategories => {
    return magentoCategories
}

export default reducer
